// import Swiper JS
import { Swiper, Pagination } from 'swiper';

export const hoverSpaces = () => {
    let hoverSpacesModules = document.querySelectorAll('.hover-spaces');

	if (hoverSpacesModules) {

        hoverSpacesModules.forEach((hoverSpacesModule) => {

            /**
             * Hover banner module background transitions
             */

            // Select all elements to check
            const hoverSpecesItems = hoverSpacesModule.querySelectorAll('.js-hover-spaces-item');

            // Add mouseover event listener to each element
            hoverSpecesItems.forEach(function(hoverSpacesItem) {
                hoverSpacesItem.addEventListener('mouseover', function() {
                
                    // get current index
                    let contentIndex = this.dataset.contentIndex;

                    // change the class
                    hoverSpecesItems.forEach(function(element) {
                        element.classList.remove('is-active');
                    });

                    // add the active class to the selected element
                    hoverSpacesModule.querySelector(`.js-hover-spaces-item[data-content-index="${contentIndex}"]`).classList.add('is-active');
                    
                    // Change bg img
                    let hoverSpacedBgs = hoverSpacesModule.querySelectorAll('.js-hover-spaces-bg');

                    // Remove the active class to all the elements
                    hoverSpacedBgs.forEach(function(element) {
                        element.classList.remove('is-active');
                    });
                
                    // add the active class to the selected element
                    hoverSpacesModule.querySelector(`.js-hover-spaces-bg[data-content-index="${contentIndex}"]`).classList.add('is-active');

                    let hoverSpacesInfo = hoverSpacesModule.querySelectorAll('.hover-spaces__info');

                    // Remove the active class to all the elements
                    hoverSpacesInfo.forEach(function(element) {
                        element.classList.remove('is-active');
                    });
                
                    // add the active class to the selected element
                    hoverSpacesModule.querySelector(`.hover-spaces__info[data-content-index="${contentIndex}"]`).classList.add('is-active');
                });
            });

            let hoverSpacesSliderSlides = hoverSpacesModule.querySelectorAll('.hover-spaces-mobile__swiper-slide');

			let slideVideos = hoverSpacesModule.querySelectorAll('.js__sslider-video');

			// Trigger the first video on page load
			if (slideVideos.length > 0) {
				for (let source in slideVideos[0].children) {
				    let videoSource = slideVideos[0].children[source];
                    if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                        videoSource.src = videoSource.dataset.src;
                    }
				}
				slideVideos[0].load();
				slideVideos[0].play();
			}

            if (hoverSpacesSliderSlides.length > 1) {
				// Initialise the slider
				const hsSwiper = new Swiper(hoverSpacesModule.querySelector('.hover-spaces-mobile__swiper-wrapper .swiper'), {
                    // configure Swiper to use modules
                    modules: [Pagination],
					centeredSlides : false,
					slidesPerView : 1.3,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
					rewind: true,
					loop: false,
                    spaceBetween: 16,
					keyboard: {
						enabled: true,
						onlyInViewport: true
					},
				});

				// Updates when a slide changes
				hsSwiper.on('slideChange', function () {
					// Stop all videos from playing
					slideVideos.forEach((slideVideo) => {
						slideVideo.pause();
						slideVideo.currentTime = 0;
						slideVideo.load();
					})

					// Check for any videos on the slide and make sure they're lazy-loaded (Had a bug with intersection observer not being triggered due to how swiper loads items)
					let slideVideo = hsSwiper.slides[hsSwiper.activeIndex].querySelector("video"); 
					if (slideVideo) {
						if (!slideVideo.currentTime > 0) { //Only reload video if it isn't already playing
							for (let source in slideVideo.children) {
                                let videoSource = slideVideo.children[source];
                                if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
                                    videoSource.src = videoSource.dataset.src;
                                }
							}
							slideVideo.load();	
							slideVideoTimeout = setTimeout(() => {
								slideVideo.play();
							},1000);
						}          
					}
				});
				
			} else {
				// Only 1 slide - don't power up swiper and just manually add the active class (doing a foreach here juuuust in case)
				hoverSpacesSliderSlides.forEach((slide) => {
					slide.classList.add('swiper-slide-active');
				})
			}
        });
    }
}